export default {
	properties: [
		{
			text: 'Descripcion',
			key: 'description',
			type: 'text',
		},
		{
			text: 'Porcentaje',
			key: 'percentage',
			type: 'number',
		},
		{
			text: 'Monto',
			key: 'monto',
			type: 'number',
		},
	],
	singular_model_name_spanish: 'Descuento de compra',
	plural_model_name_spanish: 'Descuento de compra',
	create_model_name_spanish: 'Nuevo Descuento de compra',
	text_delete: 'el',
}